var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "relative text-center",
      class: { "z-10": !_vm.isActive, "z-20": _vm.isActive },
    },
    [
      _c(
        "a",
        {
          staticClass: "inline-flex relative z-20 p-6",
          attrs: { href: _vm.item.itemLink, target: "_blank" },
          on: {
            mousemove: _vm.handleMouseover,
            mouseenter: function ($event) {
              _vm.isActive = true
            },
            mouseleave: function ($event) {
              _vm.isActive = false
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "relative text-xl leading-none",
              class: { underline: !_vm.isActive },
            },
            [_vm._v("\n      " + _vm._s(_vm.item.itemHeading) + "\n    ")]
          ),
          _vm._v(" "),
          _c("transition", { attrs: { name: "fade" } }, [
            _vm.item.itemSubHeading && _vm.isActive
              ? _c(
                  "div",
                  {
                    staticClass:
                      "absolute bottom-0 inset-x-0 text-center text-sm -mb-1 pointer-events-none",
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.item.itemSubHeading) +
                        "\n      "
                    ),
                  ]
                )
              : _vm._e(),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.isActive
          ? _c(
              "div",
              {
                staticClass: "absolute z-10",
                style: {
                  width: `40vw`,
                  left: `50%`,
                  top: `50%`,
                  transform: `translate3d(calc(-50% + ${_vm.x}),calc(-50% + ${_vm.y}),0)`,
                },
              },
              [
                _c("img", {
                  attrs: {
                    src: _vm.item.itemImage[0].url,
                    alt: _vm.item.itemImage[0].title,
                  },
                }),
              ]
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }